import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import classes from './Container.scss';

const propTypes = {
  children: PropTypes.node,
  site: PropTypes.shape({
    blogSettings: PropTypes.shape({
      title: PropTypes.string,
    }).isRequired,
  }).isRequired,
};
const defaultProps = {
  children: undefined,
};

const Container = ({ site: { blogSettings: { title } }, children }) => (
  <div>
    <div className={classes.titleContainer}>
      <h1 data-testid="blogTitle">{title || 'Blog'}</h1>
    </div>
    {children}
  </div>
);

Container.propTypes = propTypes;
Container.defaultProps = defaultProps;

Container.fragments = {
  currentSite: gql`
    fragment CurrentSiteBlogDataContainer on Site {
      blogSettings {
        title
      }
    }
  `,
};

export default Container;
